import React from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import EditorLoginGate from "../components/EditorLoginGate";
import StudioWorkspace from "../mockup-studio/StudioWorkspace";

/**
 * /mockup-editor?id=<listing>: the editor, opened on that listing. More
 * mockups can be added from Discover or My mockups.
 */
const MockupEditor = () => {
  const { role, isLoggedIn } = useSelector((state) => state.auth);
  const [params] = useSearchParams();
  const id = params.get("id");

  if (!isLoggedIn && role !== "A") return <EditorLoginGate />;
  // Keyed by listing so opening another listing starts a fresh session.
  return <StudioWorkspace key={id || "new"} initialListingId={id} />;
};

export default MockupEditor;
